import(/* webpackMode: "eager" */ "/app/app/(marketing)/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/CanadianBrandingWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeferredAnalytics"] */ "/app/components/marketing/DeferredAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarketingProviders"] */ "/app/components/marketing/marketing-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteFooter"] */ "/app/components/marketing/site-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/app/components/marketing/site-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientThemeColorManager"] */ "/app/components/utility/ClientThemeColorManager.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts/dm-sans.ts\",\"import\":\"DM_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-dm-sans\",\"display\":\"swap\"}],\"variableName\":\"dmSans\"}");
